module.exports = __webpack_public_path__ + "img/RX-RAD-DIGI-Sala-1-zoom.ac4a2464.png";